$(() => {
  $(".toggle-items--button").on("click", function toggleItems(event) {
    event.preventDefault()
    const $button = $(this)
    const showText = $button.data("show")
    const hideText = $button.data("hide")

    const isItemsHidden = $button
      .parent()
      .toggleClass("toggle-items_show")
      .find(".toggle-items--i")
      .toggleClass("toggle-items--i_hidden")
      .first()
      .hasClass("toggle-items--i_hidden")

    $button.text(isItemsHidden ? showText : hideText)
  })
})
